import { gql } from '@apollo/client';

export const CREATE_DYNAMIC_CONFIG_ITEM = gql`
  mutation CreateDynamicConfigItem($data: CreateDynamicConfigItemInput!) {
    createDynamicConfigItem(data: $data) {
      data {
        configSubtype
        configType
        description
        itemKey
        value
        isActive
      }
      message
    }
  }
`;

export const UPDATE_DYNAMIC_CONFIG_ITEM = gql`
  mutation UpdateDynamicConfigItem(
    $where: DynamicConfigItemUniqueInput!
    $data: UpdateDynamicConfigItemInput
  ) {
    updateDynamicConfigItem(where: $where, data: $data) {
      data {
        id
        configType
        configSubtype
        itemKey
        value
        description
        isActive
        createdAt
        updatedAt
      }
      message
    }
  }
`;

export const UPDATE_PINCODE_DELIVERY_SCHEDULE = gql`
  mutation UpdatePincodeDeliverySchedule(
    $where: UpdatePincodeDeliveryScheduleWhereInput!
    $data: UpdatePincodeDeliveryScheduleInput!
  ) {
    updatePincodeDeliverySchedule(where: $where, data: $data) {
      count
      message
      data {
        id
        pincodeId
        pincode {
          id
          pincode
          areaName
          library {
            id
            name
          }
        }
        isActive
        config
        updatedAt
      }
    }
  }
`;

export const CREATE_TOY_RESERVATION_RULE = gql`
  mutation CreateToyReservationRule($data: CreateToyReservationRuleInput!) {
    createToyReservationRule(data: $data) {
      id
      name
      type
      config
      isActive
      createdBy
      createdAt
      updatedAt
      attachmentCount
    }
  }
`;

export const UPDATE_TOY_RESERVATION_RULE = gql`
  mutation UpdateToyReservationRule(
    $where: ToyReservationRuleUniqueInput!
    $data: UpdateToyReservationRuleInput!
  ) {
    updateToyReservationRule(where: $where, data: $data) {
      id
      name
      type
      config
      isActive
      createdBy
      createdAt
      updatedAt
      attachmentCount
    }
  }
`;

export const DELETE_TOY_RESERVATION_RULE = gql`
  mutation DeleteToyReservationRule($where: ToyReservationRuleUniqueInput!) {
    deleteToyReservationRule(where: $where) {
      message
      code
    }
  }
`;

export const ATTACH_TOY_RESERVATION_RULE = gql`
  mutation AttachToyReservationRule($data: AttachToyReservationRuleInput!) {
    attachToyReservationRule(data: $data) {
      count
      data {
        id
        libraryInventoryId
        toyReservationRuleId
        isActive
        ruleGroup
        sortOrder
        createdAt
        updatedAt
      }
    }
  }
`;
